import { Color } from '../../enums';

const state = {
  id: -1,
  name: navigator.language === 'de' ? 'Fridolin Schlau' : 'Fridolin Smart',
  solvedTasks: '',
  owlColor: Color.BLUE,
  headAccessoir: 0,
  bodyAccessoir: 0,
};

const getters = {
  tasksWithStatus(state, getters, rootState) {
    var solvedTasksArray = state.solvedTasks.split("\n").map(x => parseInt(x))

    return rootState.tasks.tasks.map((task) => {
      const updatedTask = task;
      updatedTask.locked = false
      updatedTask.done = solvedTasksArray.some(x => x == task.id );
      return updatedTask;
    });
  },
  name: state => state.name,
};

const actions = {
  complete({ commit }, { taskSolvedId, wm }) {
      var newSolvedTasks = state.solvedTasks + "\n"+ taskSolvedId
      commit('setTaskSolved', newSolvedTasks);
      wm.$cookie.set('solved-tasks', newSolvedTasks);
  },
  loadTaskSolved({ state }, { wm }) {
    var solvedTasks = wm.$cookie.get('solved-tasks');
    if (solvedTasks)
      state.solvedTasks = solvedTasks
    else 
      state.solvedTasks = ''
  },
  saveUserName({ commit }, { value }) {
    commit('setUsername', value);
  }
};

const mutations = {
  setTaskSolved(state, taskSolved) {
    state.solvedTasks = taskSolved;
  },
  setUsername(state, name) {
    state.name = name;
  },
  setOwlColor(state, color) {
    state.owlColor = color;
  },
  setBodyAccessoir(state, acc){
    state.bodyAccessoir = acc;
  },
  setHeadAccessoir(state, acc){
    state.headAccessoir = acc;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
